module.exports = __webpack_public_path__ + "img/17-CFW.8140320.jpg";